import { BaseEntityAdapter } from "@brains/plugins";
import { slugify } from "@brains/utils/string-utils";
import {
  wishSchema,
  wishFrontmatterSchema,
  type WishEntity,
  type WishFrontmatter,
  type WishMetadata,
} from "../schemas/wish";

export class WishAdapter extends BaseEntityAdapter<
  WishEntity,
  WishMetadata,
  WishFrontmatter
> {
  constructor() {
    super({
      entityType: "wish",
      purpose:
        "A demand record the assistant proactively creates when a user requests a capability or outcome no installed tool can fulfill, unless the user declines.",
      schema: wishSchema,
      frontmatterSchema: wishFrontmatterSchema,
    });
  }

  public createWishContent(
    frontmatter: WishFrontmatter,
    description: string,
  ): string {
    return this.buildMarkdown(description, frontmatter);
  }

  public parseWishContent(content: string): {
    frontmatter: WishFrontmatter;
    description: string;
  } {
    // Parse through schema to apply defaults (priority, requested)
    const raw = this.parseFrontMatter(content, wishFrontmatterSchema);
    return {
      frontmatter: wishFrontmatterSchema.parse(raw),
      description: this.extractBody(content).trim(),
    };
  }

  public fromMarkdown(markdown: string): Partial<WishEntity> {
    const { frontmatter } = this.parseWishContent(markdown);
    const slug = slugify(frontmatter.title);
    return {
      content: markdown,
      entityType: "wish",
      metadata: {
        title: frontmatter.title,
        status: frontmatter.status,
        priority: frontmatter.priority,
        requested: frontmatter.requested,
        slug,
      },
    };
  }
}

export const wishAdapter: WishAdapter = new WishAdapter();
